export { SafeSidebarWorkspaceHeader } from './SafeSidebarWorkspaceHeader'
export type { SafeSidebarWorkspaceHeaderProps } from './SafeSidebarWorkspaceHeader'
